import { render, staticRenderFns } from "./ProfileFeedFilters.vue?vue&type=template&id=06d9d74a&scoped=true&"
import script from "./ProfileFeedFilters.vue?vue&type=script&lang=ts&"
export * from "./ProfileFeedFilters.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileFeedFilters.vue?vue&type=style&index=0&id=06d9d74a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d9d74a",
  null
  
)

export default component.exports